// @flow
import React from 'react';
import { Row, Col } from 'Components/Grid';
import Button from 'Components/Button';
import Price from 'Components/Price';
import Typography from 'Components/Typography';
import FocusedImage from 'Components/FocusedImage';
import Link from 'Components/Link';
import AccessoryModel from 'Stores/AccessoryModel';
import Icon from 'Components/Icon';
import { emailTracking } from 'Utils/trackingAttributes';
import styles from './styles.scss';
import DealerModel from 'Stores/DealerModel';
import GlobalContext from '../../context/Global/index';

type Props = {
  part: AccessoryModel,
  model: string,
  year: string,
  dealer: DealerModel,
};

export default class AccessoriesEntry extends React.Component<Props> {
  render() {
    const { part, model, year, dealer } = this.props;

    const href =
      '/service/zubehoer/zubehoerkatalog/details/' +
      `?part=${part.partNumber}&model=${model}&year=${year}`;

    return (
      <GlobalContext.Consumer>
        {({ updateGlobalContext }) => (
          <Row>
            <Col m={12}>
              <div className={styles.part}>
                {part.mainImages && (
                  <div className={styles.imgWrapper}>
                    <FocusedImage className={styles.img} image={{ src: part.getMainImage() }} />
                  </div>
                )}
                <div className={styles.contentWrapper}>
                  <div className={styles.content}>
                    <Typography.Headline level="h4" value={part.getTitle()} forceUppercase={true} />
                  </div>
                  <div className={styles.footer}>
                    <div className={styles.buttons}>
                      <div className={styles.request}>
                        <Button
                          label="Anfrage"
                          ariaLabel={`Anfrage - öffnet Modal, um den Serviceberater zu ${part.getTitle()} zu kontaktieren`}
                          variant="primary"
                          href={'?modaltype=SERVICE_REQUEST&showmodal=true'}
                          trackingLabel="servicecontact_pa"
                          onClick={() => {
                            updateGlobalContext(undefined, undefined, {
                              selectedAccessoryPart: `${part.accessoryName}, Nr.: ${part.partNumber}`,
                              selectedAccessoryPartModel: part,
                            });
                          }}
                        />
                      </div>
                      <div className={styles.moreInformation}>
                        <Button
                          label="Mehr Informationen"
                          ariaLabel={`Mehr Informationen zu ${part.getTitle()}`}
                          variant="secondary"
                          href={href}
                        />
                      </div>
                    </div>
                    <div className={styles.price}>
                      {dealer.settings.showAccessoryPrice && part.rrpInclVAT > 0 && (
                        <Price
                          small
                          value={part.priceInclFitting()}
                          subline={
                            part.showPriceWithFittingCosts()
                              ? 'inkl. Einbaukosten'
                              : 'exkl. Einbaukosten'
                          }
                        />
                      )}

                      {!dealer.settings.showAccessoryPrice && (
                        <div>
                          <div>Preis auf Anfrage</div>
                          <div className={styles.priceInfo}>
                            <Icon name="mail-small" inline={false} />
                            <Link
                              to={`mailto:${
                                dealer.mainContact.email
                              }?subject=Mazda Zubehör Anfrage&body=Ich interessiere mich für ${model} ${year} ${
                                part.categoryLabel
                              } ${part.getTitle()}`}
                              {...emailTracking('Dealer Contact Dropdown')}
                              label={dealer.mainContact.email}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </GlobalContext.Consumer>
    );
  }
}
